import React, { Fragment } from "react";
import PropTypes from "prop-types";

const HPIIHistoryRecord = ({ HPIIHistoryRecordData }) => (
  <Fragment>
    {HPIIHistoryRecordData && HPIIHistoryRecordData.length > 0 ? (
      <table className="table table-striped">
        <thead>
          <tr>
            <th scope="col">Updated Date</th>
            <th scope="col">HPII Number</th>
            <th scope="col">HPII Status</th>
            <th scope="col">Operator</th>
          </tr>
        </thead>
        <tbody>
          {HPIIHistoryRecordData.map((item, index) => (
            <tr key={index}>
              <td>{new Date(item.createdAt).toLocaleDateString("es-cl")}</td>
              <td>{item.HPIINumber}</td>
              <td>{item.HPIIStatus}</td>
              <td>{item.operator}</td>
            </tr>
          ))}
        </tbody>
      </table>
    ) : (
      <p>No results.</p>
    )}
  </Fragment>
);

export default HPIIHistoryRecord;

HPIIHistoryRecord.prototype = {
  historyRecord: PropTypes.array
};
